// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organization-wrapper .ant-space-gap-col-small {
  -moz-column-gap: 0;
       column-gap: 0;
}
.organization-wrapper .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  background-color: transparent;
  border: none;
  color: #fff;
  padding-left: 5px;
}
.organization-wrapper .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector .ant-select-arrow {
  vertical-align: middle;
}
.organization-wrapper .ant-select-single {
  font-size: 15px;
}
.organization-wrapper .ant-select .ant-select-arrow {
  color: #fff;
}
.organization-wrapper .ant-select-selection-item {
  font-size: 20px;
}
.organization-wrapper .organization-icon {
  color: #fff;
  font-size: 20px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/organisations/Organization.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;OAAA,aAAA;AAAJ;AAII;EACE,6BAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAFN;AAIM;EACE,sBAAA;AAFR;AAOE;EACE,eAAA;AALJ;AAQE;EACE,WAAA;AANJ;AASE;EACE,eAAA;AAPJ;AAUE;EACE,WAAA;EACA,eAAA;EACA,sBAAA;AARJ","sourcesContent":[".organization-wrapper {\n  .ant-space-gap-col-small {\n    column-gap: 0;\n  }\n\n  .ant-select-outlined:not(.ant-select-customize-input) {\n    .ant-select-selector {\n      background-color: transparent;\n      border: none;\n      color: #fff;\n      padding-left: 5px;\n\n      .ant-select-arrow {\n        vertical-align: middle;\n      }\n    }\n  }\n\n  .ant-select-single {\n    font-size: 15px;\n  }\n\n  .ant-select .ant-select-arrow {\n    color: #fff;\n  }\n\n  .ant-select-selection-item {\n    font-size: 20px;\n  }\n\n  .organization-icon {\n    color: #fff;\n    font-size: 20px;\n    vertical-align: middle;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
